import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-about-rgi',
  templateUrl: './about-rgi.component.html',
  styleUrls: ['./about-rgi.component.scss']
})
export class AboutRgiComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
